import styles from './form.module.css';



const Form = () => {
   return (
      <form action="#" className={styles.form}>
         <input autoComplete="off" type="text" name='form[]' placeholder='Введите свое мыло' className={styles.form__input} />
         <button tupe="submit" className={styles.form__btn}>SEND</button>
      </form>
   );
}

export default Form;